/* eslint-disable camelcase */
import React from "react";
import cn from "classnames";
import { joinExisting } from "utils/strings";
import { EmployeeCardProps } from "./EmployeeCard";
import baseStyles from "./EmployeeCard.module.scss";
import styles from "./Hero.module.scss";

export const Hero = ({
    className,
    employee,
    onClick,
    ...props
}: EmployeeCardProps) => {
    const {
        description,
        first_name,
        employee_photo,
        job_title,
        last_name,
    } = employee;
    const title = joinExisting([first_name, last_name]);
    return (
        <article
            className={cn(styles.wrapper, className)}
            {...props}
            style={{ "--bg-img": `url(${employee_photo})` } as React.CSSProperties}
        >
            <div className={styles.body}>
                <h3 className={styles.title}>{title}</h3>
                {!!job_title && <p className={cn(baseStyles.subheading, styles.subheading)}>{job_title}</p>}
                <p className={cn(baseStyles.description, styles.description)}>{description}</p>
            </div>
            <button
                className={cn(baseStyles.cta, styles.cta)}
                onClick={onClick}
                type="button"
            >
                Learn More
            </button>
        </article>
    );
};
